import(/* webpackMode: "eager", webpackExports: ["ContentsWrapper"] */ "/vercel/path0/src/components/ContentsWrapper.tsx");
